module.exports = __webpack_public_path__ + "Icono_Eliminar_512px.png";